import script from "./programPageInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./programPageInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__